import React, { useState } from 'react';
import {Button, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import moment from 'moment';
import { RazorpayOrderReferenceModelEnums } from '../../enums/RazorpayOrderReferenceModelEnums';
import PartialRefundDialog from '../Common/PartialRefundDialog';


const TransactionV3ListForModule = (props: any) => {
    const [partialRefundOpen, setPartialRefundOpen] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);

    function getCouponExtensionRequestId(row: any): number | null {
        const candidateIds = [
            row?.expiryExtensionRequestId,
            row?.referenceModelId,
            row?.referenceId,
            row?.id,
        ];

        for (const candidate of candidateIds) {
            const parsed = Number(candidate);
            if (!Number.isNaN(parsed) && parsed > 0) return parsed;
        }

        return null;
    }

    function getLink(row: any, modelName:string){
        const referenceId = row?.referenceId;
        if(modelName===RazorpayOrderReferenceModelEnums.ONE_MEAL_SERVICE){
            return `/#/OneMealService/${referenceId}/show`
        }
        else if(modelName===RazorpayOrderReferenceModelEnums.TRIAL_V3){
            return `/#/Trials/${referenceId}/show`
        }
        else if(modelName===RazorpayOrderReferenceModelEnums.USER_BUNDLE_PAYMENTS){
            return `/#/UserBundles/${referenceId}/show`
        }
        else if(
            modelName===RazorpayOrderReferenceModelEnums.DISCOUNT_COUPON_ORDER ||
            modelName===RazorpayOrderReferenceModelEnums.COUPON_ORDER_EXPIRY_EXTENSION
        ){
            if(modelName===RazorpayOrderReferenceModelEnums.COUPON_ORDER_EXPIRY_EXTENSION){
                const extensionRequestId = getCouponExtensionRequestId(row);
                return extensionRequestId
                    ? `/#/coupon-expiry-extension/${extensionRequestId}`
                    : "#";
            }
            return `/#/Combo/${referenceId}/show`
        }
        else{
            return `/#/ChefForParty/${referenceId}/show`
        }
    }

    return (
        <>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Currency</TableCell>
                        <TableCell>Order Id</TableCell>
                        <TableCell>Refund amount</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Reference Id</TableCell>
                        <TableCell>Razorpay Success Payment Id</TableCell>
                        <TableCell>Payment Date</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((row: any) => {
                        const refundable = Number(row?.amount) - Number(row?.refundAmount || 0);
                        const canRefund = row?.state === 'PAID' && refundable > 0;
                        return (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell scope="row">{row?.id}</TableCell>
                                <TableCell align="left">{row?.amount}</TableCell>
                                <TableCell align="left">{row?.currency}</TableCell>
                                <TableCell align="left">{row?.razorpayOrderId}</TableCell>
                                <TableCell align="left">{row?.refundAmount}</TableCell>
                                <TableCell align="left">{row?.state}</TableCell>
                                <TableCell align="left">
                                    <Link href={getLink(row, props?.modelName)}>
                                        {row?.referenceId}
                                    </Link>
                                </TableCell>
                                <TableCell align="left">{row?.razorpaySuccessPaymentId}</TableCell>
                                <TableCell align="left">{row?.paymentDate ? moment(row?.paymentDate).format("DD-MM-YYYY hh:mm A") : '-'}</TableCell>
                                <TableCell align="left">
                                    <Button
                                        variant="contained"
                                        color="error"
                                        size="small"
                                        disabled={!canRefund}
                                        onClick={() => {
                                            setSelectedRow(row);
                                            setPartialRefundOpen(true);
                                        }}
                                    >
                                        Partial Refund
                                    </Button>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
        {partialRefundOpen && selectedRow && (
            <PartialRefundDialog
                open={partialRefundOpen}
                razorpayOrderId={selectedRow.id}
                maxRefundable={Number(selectedRow?.amount) - Number(selectedRow?.refundAmount || 0)}
                onClose={() => setPartialRefundOpen(false)}
                onSuccess={() => {
                    setPartialRefundOpen(false);
                    setSelectedRow(null);
                    if (props.onCallback) props.onCallback();
                }}
            />
        )}
        </>
    );
};

export default TransactionV3ListForModule;
